import { useState, useEffect } from 'react';
import healthService from '../services/healthService';

export const useHealthCheck = (interval = 30000) => {
  const [health, setHealth] = useState({
    status: 'unknown',
    checks: {},
    timestamp: null,
  });
  const [isHealthy, setIsHealthy] = useState(true);
  const [error, setError] = useState(null);
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    const checkHealth = async () => {
      try {
        const response = await healthService.getHealth();
        setHealth(response);
        setIsHealthy(response.status === 'healthy');
        setError(null);
        // Reset retry count on successful health check
        if (retryCount > 0) {
          setRetryCount(0);
        }
      } catch (error) {
        // FIXED: Improved error handling with logging and retry tracking
        setIsHealthy(false);
        setError(error?.message || 'Health check failed');
        setRetryCount((prev) => prev + 1);

        setHealth({
          status: 'unhealthy',
          checks: {},
          timestamp: new Date().toISOString(),
          error: error?.message || 'Unknown error',
        });

        // Log error in development mode only
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.error('Health check failed:', {
            error: error?.message,
            retryCount: retryCount + 1,
            timestamp: new Date().toISOString(),
          });
        }
      }
    };

    checkHealth();
    const intervalId = setInterval(checkHealth, interval);

    return () => clearInterval(intervalId);
  }, [interval, retryCount]);

  return { health, isHealthy, error, retryCount };
};
